// extracted by mini-css-extract-plugin
export default {"deleteCell":"styles_deleteCell__TOw9h","deleteButton":"styles_deleteButton__ul9Cr","iconContainer":"styles_iconContainer__NhQxW"};